<template>
  <el-select
    v-bind="$attrs"
    v-on="$listeners"
    :style="{ width: $attrs.innerWidth || '' }"
  >
    <slot />
  </el-select>
</template>

<script>
export default {
  name: "my-select",
  components: {},
  watch: {},
  mounted() {
    //初始化设置  下拉框宽度适应父输入框宽度
    const SELECT = this.$el;
    const DROPDOWN = this.$el.querySelectorAll(".el-select-dropdown")[0];
    DROPDOWN.style.width = SELECT.getBoundingClientRect().width + "px";
  },
};
</script>
<style lang="scss" scoped>
>>> .el-select-dropdown {
  min-width: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MySelect.vue